<template>
  <div class="main">
    <!-- 标题 -->
    <div class="herder-title">{{ code ? "登录绑定" : "密码登录" }}</div>

    <!-- 输入框 -->
    <div class="input-box1">
      <input v-model="phone" placeholder="请输入手机号码" />
      <div class="left">
        +86 <img src="@/assets/mobile/image/common/arrow.png" />
      </div>
    </div>

    <div class="input-box2">
      <input v-model="password" :type="type" placeholder="请输入登录密码" />
      <div class="right">
        <img
          @click="type = 'text'"
          v-if="type === 'password'"
          src="@/assets/mobile/image/common/close.png"
        />
        <img
          @click="type = 'password'"
          v-if="type === 'text'"
          src="@/assets/mobile/image/common/open.png"
        />
      </div>
    </div>

    <!-- 忘记密码 -->
    <div class="forgot-password" @click="gourl('/mobile/forgotPassword')">
      忘记密码？
    </div>

    <!-- 登录按钮 -->
    <button
      :class="`btn ${flag ? 'btn-active' : ''}`"
      @click="sunmit('/mobile/home')"
    >
      登录
    </button>

    <!-- 验证码登录 -->
    <div class="code" @click="gourl('/mobile/register')">立即注册</div>

    <!-- 其它方式登录 -->
    <div class="other">
      <span></span>
      <div>其他登录方式</div>
      <span></span>
    </div>
    <img
      class="weixin"
      src="@/assets/mobile/image/common/weixin.png"
      @click="getWeChatAuthWechatUrl"
    />

    <div class="radio-box">
      <van-radio-group v-model="radio">
        <van-radio name="1"></van-radio>
      </van-radio-group>
      <div class="radio-name">
        登录即代表同意《爱答卷》<span>用户协议</span>和<span>隐私政策</span>
      </div>
    </div>
  </div>
</template>
<script>
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
import { setLogin, getAccount, getWeChatAuthWechatUrl } from "@/api/mobile";
export default {
  data() {
    return {
      phone: null,
      password: null,
      radio: null,
      type: "password",
      flag: false,
      state: null,
      redirectUrl: null,
      url: null,
      code: null,
    };
  },
  methods: {
    gourl(path) {
      if (this.code) {
        this.$router.push(path + "?code=" + this.code);
      } else {
        this.$router.push(path);
      }
    },

    sunmit(path) {
      if (!this.radio) {
        this.$toast("请先同意隐私政策和服务协议");
        return;
      }

      if (this.flag) {
        return;
      }
      this.flag = true;
      localStorage.setItem("login", true);
      setLogin({
        phone: this.phone,
        password: this.password,
        weChatCode: this.code,
      }).then((res) => {
        this.flag = false;
        if (res.code === 200) {
          localStorage.setItem("token", res.data.token);
          getAccount().then((res) => {
            if (res.code === 200) {
              localStorage.setItem("userInfo", JSON.stringify(res.data));
              this.$router.push(path);
            }
          });
        }
      });
    },

    getWeChatAuthWechatUrl() {
      if (!this.radio) {
        this.$toast("请先同意隐私政策和服务协议");
        return;
      }
      this.state = generateUUID();
      this.redirectUrl = `https://www.aidajuan.com/mobile/landingPage`;
      getWeChatAuthWechatUrl({
        redirectUrl: this.redirectUrl,
        state: this.state,
      }).then((res) => {
        if (res.code === 200) {
          this.url = res.data;
          window.location.href = res.data;
        }
      });
    },
  },
  created() {
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
    }
  },
};
</script>
<style lang="scss" scoped>
.state {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  white-space: normal; /* 允许文本换行 */
  word-break: break-word; /* 在单词边界处换行 */
  overflow-wrap: break-word; /* 另一种设置，确保长单词可以换行 */
}
.main {
  width: 100%;
  min-height: calc(100vh - 125px);
  background-color: #faf8ff;
  background-image: url("../../assets/mobile/image/common/shadow.png");
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 85px;
  padding-bottom: 40px;
  .herder-title {
    text-align: center;
    color: #232323;
    font-size: 23px;
    font-weight: bolder;
  }
  .input-box1 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 334px;
    height: 50px;
    background: #ffffff;
    border-radius: 29px 29px 29px 29px;
    margin-top: 31px;
    input {
      height: 50px;
      width: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      color: #232323;
      border-radius: 29px 29px 29px 29px;
      box-sizing: border-box;
      padding: 0 20px 0 70px;
    }
    .left {
      position: absolute;
      color: #232323;
      font-size: 16px;
      display: flex;
      align-items: center;
      left: 20px;
      img {
        width: 10px;
        height: 10px;
        margin-left: 2px;
      }
    }
  }
  .input-box2 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 334px;
    height: 50px;
    background: #ffffff;
    border-radius: 29px 29px 29px 29px;
    margin-top: 15px;
    input {
      height: 50px;
      width: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      color: #232323;
      border-radius: 29px 29px 29px 29px;
      box-sizing: border-box;
      padding: 0 54px 0 20px;
    }
    .right {
      position: absolute;
      color: #232323;
      font-size: 16px;
      display: flex;
      align-items: center;
      right: 20px;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  //忘记密码
  .forgot-password {
    color: #8846ff;
    font-size: 14px;
    text-align: center;
    margin-top: 17px;
    cursor: pointer;
  }
  //登录按钮
  .btn {
    padding: 0;
    border: none;
    width: 90%;
    max-width: 334px;
    height: 50px;
    background: linear-gradient(138deg, #c2a0ff 0%, #8846ff 100%);
    border-radius: 25px 25px 25px 25px;
    color: #fff;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 119px;
    font-size: 16px;
    cursor: pointer;
  }
  .btn-active {
    opacity: 0.7;
  }

  //验证码登录
  .code {
    color: #8846ff;
    font-size: 14px;
    text-align: center;
    margin-top: 15px;
    cursor: pointer;
  }

  //其它方式登录
  .other {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666666;
    font-size: 12px;
    margin-top: 80px;
    span {
      width: 41px;
      height: 1px;
      background: #eeedf2;
      margin: 0 18px;
    }
  }
  .weixin {
    width: 32px;
    height: 32px;
    margin-top: 11px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .radio-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 49px;
    .radio-name {
      font-size: 12px;
      margin-left: 5px;
      span {
        color: #8846ff;
      }
    }
  }
}
</style>
<style>
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c1c1c1;
  opacity: 1;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c1c1c1;
  opacity: 1;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c1c1c1;
  opacity: 1;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c1c1c1;
  opacity: 1;
}
.main >>> .van-radio__label {
  font-size: 12px;
}
</style>